module.exports = __webpack_public_path__ + "static/media/back.854e0586.png";